export const APPLICATION_ID = '9d67bac4-f6b3-408b-bc34-3ca8da9c5baa';
export const CLIENT_TOKEN = 'pub43f15cef75c72e6bb889d24d8cc8b494';
